const initialState = {
    pending: false,
    groups: [],
    error: null
};

const sensorGroupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SENSOR_GROUPS_PENDING':
            return {...state, pending: true, error: null};
        case 'SENSOR_GROUPS_ERROR':
            return {...state, pending: false, error: action.error};
        case 'GET_SENSOR_GROUPS_SUCCESS':
            return {...state, pending: false, groups: action.groups};
        case 'CREATE_SENSOR_GROUP_SUCCESS':
            return {...state, pending: false, groups: [...state.groups, action.group]};
        case 'UPDATE_SENSOR_GROUP_SUCCESS':
            return {
                ...state,
                pending: false,
                groups: state.groups.map(group =>
                    group.id === action.group.id ? action.group : group
                )
            };
        case 'DELETE_SENSOR_GROUP_SUCCESS':
            return {
                ...state,
                pending: false,
                groups: state.groups.filter(group => group.id !== action.groupId)
            };
        default:
            return state;
    }
};

export default sensorGroupsReducer;
